var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasPlatform
    ? _c("BaseStatus", {
        attrs: {
          soft: "",
          preserveCase: "",
          color: "primary",
          content: _vm.platformLabel
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }